import { useEffect } from 'react'

import { EAgentKeys, TChatSettings } from '~/features/agents/models'
import { getAgentChatSettings } from '~/features/agents/utils'
import useSignoutContext from '~/features/auth/hooks/useSignoutContext'
import useIsEmbeddedChat from '~/features/chatbot/hooks/useIsEmbeddedChat'
import { sendLoadIconStyles } from '~/features/chatbot/utils'
import { store } from '~/store'

type TProps = {
  isLoading: boolean
}

const useEmbeddedIconStyles = ({ isLoading }: TProps) => {
  const { isEmbedded } = useIsEmbeddedChat()

  const chatbot = store((state) => state.chatbot)
  const chatSettings =
    getAgentChatSettings(chatbot.agent[EAgentKeys.chatSettings]) ||
    ({} as TChatSettings)
  const { embedIconBGColor, embedIconColor, embedIconShape } = chatSettings

  const { isSigningOut } = useSignoutContext()

  useEffect(() => {
    if (isLoading || isSigningOut) return

    if (isEmbedded) {
      sendLoadIconStyles({
        iconBackgroundColor: embedIconBGColor || '',
        iconColor: embedIconColor || '',
        iconShape: embedIconShape,
      })
    }
  }, [
    embedIconBGColor,
    embedIconColor,
    embedIconShape,
    isEmbedded,
    isLoading,
    isSigningOut,
  ])
}

export default useEmbeddedIconStyles
